import { observer } from "mobx-react-lite";
import { Button } from "primereact/button";
import React from "react";
import styled from "styled-components";
import { useReactMenuProps } from "../../../generic-components/common/useReactMenuProps";
import { DeepFriedMenuItem } from "../../../generic-components/menu/DeepFriedMenuItem";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { completeMenuItem } from "../MenuItems/completeMenuItem";
import { useNavItems } from "../MenuItems/useNavItems";
import { StyledReactControlledMenu } from "../ProfileMenu/SharedStyles";
import { useLanguageMenuItem } from "../ProfileMenu/useLanguageMenuItem";
import { useSettings } from "../../../settings/useSettings";

export const EmbedNavMenu = observer(() => {
  const { confirmedLoggedIn } = useWhoAmI();
  const { controlledMenuProps, btnProps } = useReactMenuProps();
  const langItem = useLanguageMenuItem();
  const settings = useSettings();

  let { navItems, loginOutItems } = useNavItems({
    showLinksThatRequireLogin: confirmedLoggedIn,
    showHome: false,
    showJobs: true,
  });

  navItems = navItems.map((item) => completeMenuItem(item));
  loginOutItems = loginOutItems.map((item) => completeMenuItem(item));

  const allItems = [...navItems];

  allItems.push({
    separator: true,
  });

  if (!settings?.iframe_overrideLocale) {
    allItems.push(completeMenuItem(langItem));
  }

  allItems.push(...loginOutItems);

  return (
    <>
      <StyledEmbedMenuBtn
        className="cvp-card-embed__menu-btn"
        icon="pi pi-bars"
        aria-controls="popup_menu"
        aria-haspopup
        {...btnProps}
      />

      <StyledReactControlledMenu {...controlledMenuProps}>
        {allItems.map((pItem, index) => {
          return (
            <DeepFriedMenuItem pItem={pItem} key={`${index}_${pItem.label}`} />
          );
        })}
      </StyledReactControlledMenu>
    </>
  );
});

export const StyledEmbedMenuBtn = styled(Button)`
  &.cvp-card-embed__menu-btn {
    width: auto;

    margin-left: -0.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    background-color: transparent;
    border: none;
    color: var(--primary-500);

    &:hover:not(:disabled) {
      background-color: transparent;
      color: var(--primary-300);
    }
    &:active:not(:disabled) {
      border: none;
    }
    &:focus:not(:disabled) {
      box-shadow: none;
    }
  }
`;
